<template>
  <div class="cont">
    <Navbar :dialogLoginVisible.sync="loginFormShow"></Navbar>

    <div
      class="bg d-flex"
      :style="{
        'background-image': `url( ${require('@/assets/img/personal/bg.png')} )`,
      }"
      style="margin-top: 40px"
    >
      <div
        style="flex: 1; align-items: center; flex-shrink: 0; min-width: 0"
        class="d-flex"
      >
        <el-image
          style="
            width: 68px;
            height: 68px;
            border-radius: 50%;
            margin-left: 4px;
            margin-right: 8px;
          "
          v-if="
            homeInfo && homeInfo.accountModel && homeInfo.accountModel.photo
          "
          :src="homeInfo.accountModel.photo"
          fit="cover"
        >
          <div slot="placeholder" class="image-slot"></div>
        </el-image>
        <el-image
          style="width: 68px; height: 68px; margin-left: 4px; margin-right: 8px"
          v-else
          :src="require('../assets/img/ava.png')"
          fit="cover"
        >
          <div slot="placeholder" class="image-slot"></div>
        </el-image>

        <div
          class="d-flex"
          style="
            flex-direction: column;
            justify-content: center;
            flex: 1;
            max-width: 100%;
            flex-shrink: 0;
            min-width: 0;
            font-size: 24px;
            height: 110px;
            line-height: 24px;
          "
          v-if="
            homeInfo && homeInfo.accountModel && homeInfo.accountModel.uname
          "
        >
          <div style="display: flex; align-items: center">
            {{ homeInfo.accountModel.uname }}

            <el-image
              style="
                width: 26px;
                height: 14px;
                margin-right: 2px;
                margin-left: 2px;
              "
              :src="require('../assets/img/waterfall/vip.png')"
              fit="contain"
              v-if="
                homeInfo && homeInfo.accountModel && homeInfo.accountModel.vip
              "
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>

            <template v-if="page_user != ac_data.uid">
              <el-button
                round
                size="mini"
                style="
                  width: 60px;
                  color: #9a9ab7;
                  background: #252739;
                  border: none;
                  margin-left: 4px;
                  text-align: center;
                  padding: 7px 0;
                "
                v-if="gz"
                @click.stop="cancelGz"
                >已关注</el-button
              >
              <el-button
                round
                size="mini"
                style="
                  width: 60px;
                  color: #fff;
                  background: #006fff;
                  border: none;
                  margin-left: 4px;
                  text-align: center;
                  padding: 7px 0;
                "
                v-else
                @click.stop="addGz"
                >关注</el-button
              >
            </template>

            <el-image
              style="width: 16px; height: 16px; margin-left: 6px"
              :src="require('../assets/img/personal/edit.png')"
              fit="contain"
              @click="accountSettingsShow = true"
              v-if="page_user == ac_data.uid"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
          </div>
          <div
            style="
              font-size: 14px;
              color: #9a9ab7;
              overflow: hidden;
              max-height: 65px;
              margin-top: 2px;
            "
            class="text-ellipsis"
          >
            {{
              homeInfo && homeInfo.accountModel.remark
                ? homeInfo.accountModel.remark
                : "这个人很个性，什么都没留下"
            }}
          </div>
        </div>
      </div>
      <div
        style="
          width: 600px;
          flex-shrink: 0;
          justify-content: flex-end;
          align-items: flex-end;
        "
        class="d-flex"
      >
        <div
          style="text-align: center; margin-right: 47px; cursor: pointer"
          @click.stop="toGroup(0)"
        >
          <div style="font-size: 24px; font-weight: 500; color: #ffffff">
            {{ homeInfo && homeInfo.gzNum ? homeInfo.gzNum : 0 }}
          </div>
          <div style="font-size: 16px; color: #9a9ab7">关注</div>
        </div>
        <div
          style="text-align: center; margin-right: 47px; cursor: pointer"
          @click.stop="toGroup(1)"
        >
          <div style="font-size: 24px; font-weight: 500; color: #ffffff">
            {{ homeInfo && homeInfo.fsNum ? homeInfo.fsNum : 0 }}
          </div>
          <div style="font-size: 16px; color: #9a9ab7">粉丝</div>
        </div>

        <div style="text-align: center; margin-right: 47px">
          <div style="font-size: 24px; font-weight: 500; color: #ffffff">
            {{
              homeInfo && homeInfo.obtainLikeNum ? homeInfo.obtainLikeNum : 0
            }}
          </div>
          <div style="font-size: 16px; color: #9a9ab7">获赞</div>
        </div>
        <div style="text-align: center; margin-right: 16px">
          <div style="font-size: 24px; font-weight: 500; color: #ffffff">
            {{ homeInfo && homeInfo.publishNum ? homeInfo.publishNum : 0 }}
          </div>
          <div style="font-size: 16px; color: #9a9ab7">发布作品</div>
        </div>
        <div style="text-align: center">
          <div style="font-size: 24px; font-weight: 500; color: #ffffff">
            {{ homeInfo && homeInfo.beUsedNum ? homeInfo.beUsedNum : 0 }}
          </div>
          <div style="font-size: 16px; color: #9a9ab7">被同款数</div>
        </div>
      </div>
    </div>

    <div class="history">
      <el-tabs v-model="activeName" style="height: 100%">
        <el-tab-pane label="作品" name="1" style="height: 100%">
          <div slot="label">
            <div class="title t1"><span>作品</span></div>
          </div>
          <PersonalWaterfall
            @loginFormShowChange="loginFormShowChange"
            v-if="activeName == 1"
            :ac_data="ac_data"
          ></PersonalWaterfall>
        </el-tab-pane>
        <el-tab-pane label="画板" name="2" style="height: 100%">
          <div slot="label">
            <div class="title t2"><span>画板</span></div>
          </div>
          <DrawingBoard
            @loginFormShowChange="loginFormShowChange"
            v-if="activeName == 2"
            :ac_data="ac_data"
          ></DrawingBoard>
        </el-tab-pane>
        <el-tab-pane
          label="AI相册"
          name="3"
          style="height: calc(100% -200px)"
          v-if="page_user == ac_data.uid"
        >
          <div slot="label">
            <div class="title t2 t3"><span>AI换脸</span></div>
          </div>
          <AIPhoto
            @loginFormShowChange="loginFormShowChange"
            v-if="activeName == 3"
            :ac_data="ac_data"
          ></AIPhoto>
        </el-tab-pane>
        <el-tab-pane
          label="AI写真"
          name="4"
          style="height: calc(100% -200px)"
          v-if="page_user == ac_data.uid"
        >
          <div slot="label">
            <div class="title t2 t3"><span>AI写真</span></div>
          </div>
          <AIPhoto2
            @loginFormShowChange="loginFormShowChange"
            v-if="activeName == 4"
            :ac_data="ac_data"
          ></AIPhoto2>
        </el-tab-pane>
        <el-tab-pane
          label="高清放大"
          name="6"
          style="height: calc(100% -200px)"
          v-if="page_user == ac_data.uid"
        >
          <div slot="label">
            <div class="title t2 t3"><span>高清放大</span></div>
          </div>
          <AIPhoto3
            @loginFormShowChange="loginFormShowChange"
            v-if="activeName == 6"
            :ac_data="ac_data"
          ></AIPhoto3>
        </el-tab-pane>
        <el-tab-pane
          label="高清修复"
          name="7"
          style="height: calc(100% -200px)"
          v-if="page_user == ac_data.uid"
        >
          <div slot="label">
            <div class="title t2 t3"><span>高清修复</span></div>
          </div>
          <AIPhoto4
            @loginFormShowChange="loginFormShowChange"
            v-if="activeName == 7"
            :ac_data="ac_data"
          ></AIPhoto4>
        </el-tab-pane>
        <el-tab-pane
          label="AI滤镜"
          name="8"
          style="height: calc(100% -200px)"
          v-if="page_user == ac_data.uid"
        >
          <div slot="label">
            <div class="title t2 t3"><span>AI滤镜</span></div>
          </div>
          <AIPhoto5
            @loginFormShowChange="loginFormShowChange"
            v-if="activeName == 8"
            :ac_data="ac_data"
          ></AIPhoto5>
        </el-tab-pane>
        <el-tab-pane
          label="一键美妆"
          name="9"
          style="height: calc(100% -200px)"
          v-if="page_user == ac_data.uid"
        >
          <div slot="label">
            <div class="title t2 t3"><span>一键美妆</span></div>
          </div>
          <AIPhoto6
            @loginFormShowChange="loginFormShowChange"
            v-if="activeName == 9"
            :ac_data="ac_data"
          ></AIPhoto6>
        </el-tab-pane>
      </el-tabs>
    </div>

    <AccountSettings
      :dialogAccountSettingsShow.sync="accountSettingsShow"
      v-if="accountSettingsShow"
      @userChangeListen="userChangeListen"
    ></AccountSettings>

    <LoginForm
      :dialogLoginVisible.sync="loginFormShow"
      v-if="loginFormShow"
    ></LoginForm>
    <Status></Status>
  </div>
</template>

<script>
import { painting_home_req } from "@/api/personal";
import { user_account_req } from "@/api/user";
import Navbar from "@/components/Navbar";
import LoginForm from "@/components/LoginForm";
import PersonalWaterfall from "@/components/PersonalWaterfall";
import DrawingBoard from "@/components/DrawingBoard";
import AccountSettings from "@/components/AccountSettings";
import { interest_edit_req, interest_read_req } from "@/api/group";
import AIPhoto from "@/components/AIPhoto";
import AIPhoto2 from "@/components/AIPhoto2";
import AIPhoto3 from "@/components/AIPhoto3";
import AIPhoto4 from "@/components/AIPhoto4";
import AIPhoto5 from "@/components/AIPhoto5";
import AIPhoto6 from "@/components/AIPhoto6";
import Status from "@/components/Status";

export default {
  components: {
    Status,
    Navbar,
    LoginForm,
    PersonalWaterfall,
    DrawingBoard,
    AccountSettings,
    AIPhoto,
    AIPhoto2,
    AIPhoto3,
    AIPhoto4,
    AIPhoto5,
    AIPhoto6,
  },
  data() {
    return {
      page_user: undefined,
      loginFormShow: false,
      activeName: "1",
      homeInfo: {},
      ac_data: {},
      accountSettingsShow: false,
      gz: false,
      _user: undefined,
    };
  },
  computed: {
    infochange() {
      return this.$store.state.user.infochange;
    },
  },
  methods: {
    loginFormShowChange(data) {
      this.loginFormShow = data;
    },
    painting_home() {
      painting_home_req({
        // uid : this.$route.query.user
        uid:
          this.$route.query.user == this.ac_data.uid
            ? undefined
            : this.$route.query.user,
      }).then((res) => {
        this.homeInfo = res.data;
        this.gz = res.data.gz;
      });
    },
    async getUserAccountInfo() {
      const { data, success } = await user_account_req();
      if (success) {
        if (data.ext) {
          data.ext = JSON.parse(data.ext);
        }
        this.ac_data = data;
        this.painting_home();
      }
    },
    userChangeListen() {},
    toGroup(index) {
      if (
        this.$route.query.user == this.ac_data.uid ||
        this.$route.query.user == this.ac_data.uid
      ) {
        this.$router.push({
          name: "MyGroup", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
          params: {
            activeName: index,
          },
        });
      }
    },
    cancelGz() {
      interest_edit_req({
        status: 2,
        fid: this.homeInfo.accountModel.uid,
      }).then(() => {
        this.gz = false;
      });
    },
    addGz() {
      interest_edit_req({
        status: 1,
        fid: this.homeInfo.accountModel.uid,
      }).then(() => {
        this.gz = true;
      });
    },
  },
  mounted() {
    this.page_user = this.$route.query.user;
    this.getUserAccountInfo();

    window.addEventListener("popstate", function (event) {
      console.log(event);
    });
  },
  watch: {
    $route() {
      this.page_user = this.$route.query.user;
    },
    infochange: function (newQuestion, oldQuestion) {
      this.painting_home();
    },
    page_user() {
      this.getUserAccountInfo();
    },
  },
  activated() {
    if (this._user && this._user != this.$route.query.user) {
      this.page_user = this.$route.query.user;
      // this.getUserAccountInfo();

      if (this.ac_data.uid != this.page_user) {
        interest_read_req({
          fid: this.page_user,
        });
      }
    }
  },
  deactivated() {
    this._user = this.page_user;
  },
};
</script>

<style lang="scss" scoped>
.cont {
  padding: 60px 84px 0;
  box-sizing: border-box;
  background-color: #0b0b1f;
}

.bg {
  width: 100%;
  height: 150px;
  background-size: cover;
  background-position: center;
  margin-bottom: 40px;
  padding: 20px;
  box-sizing: border-box;
}

::v-deep .el-tabs__content {
  height: calc(100% - 55px);
}
::v-deep .el-tabs__item {
  color: #cacad4;
  font-weight: 400;
  padding: 0;
}
::v-deep .el-tabs__item.is-active {
  color: #fff;
  font-weight: 500;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #0b0b1f !important;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

/*修改.el-progress背景色*/
::v-deep .el-progress-circle__track {
  stroke: #38394b;
}

::v-deep .modal-class {
  position: relative;
  min-height: 200px;
}
::v-deep .modal-class .chevron-left {
  position: absolute;
  left: 3px;
  top: 45%;
  font-size: 30px;
  color: #fff;
}

::v-deep .modal-class .chevron-right {
  position: absolute;
  right: 3px;
  top: 45%;
  font-size: 30px;
  color: #fff;
  z-index: 999;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #111225;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

::v-deep .el-textarea__inner {
  background: #222337;
  border: none;
  color: #fff;
  &::placeholder {
    color: #49495a;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: #49495a;
  }

  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 适配火狐 */
    color: #49495a;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ 适配火狐 */
    color: #49495a;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10+  适配ie*/
    color: #49495a;
  }
}

.container-fluid {
  // background-color: #f5f6f9;
  padding-left: 5px;
  padding-right: 5px;
  height: calc(100%);
}
::v-deep .main_cont {
  height: calc(100vh - 66px);
}
.content {
  box-sizing: border-box;
  // background-color: #f5f6f9;
  height: 100%;
  .toolbox {
    text-align: left;
    padding: 12px;
    box-sizing: border-box;
    font-size: 14px;
    overflow: hidden;
    height: 100%;
    padding-right: 20px; /* 防止滚动条遮挡内容 */

    .toolbox_cont {
    }
    .title {
      font-weight: 700;
      color: #333;
      padding-bottom: 8px;
      border-bottom: 2px solid #317cf6;
    }

    .icon-item {
      width: 25%;
      margin-bottom: 12px;

      .icon {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #51a280;
        margin: 0 auto;
      }

      .name {
        font-size: 12px;
        text-align: center;
        margin-top: 3px;
      }
    }
  }

  .toolbox {
    overflow: hidden;
  }
  .toolbox::-webkit-scrollbar {
    width: 1px;
    display: flex;
  }
  .toolbox::-webkit-scrollbar-thumb {
    background: #3ba9f8;
  }
  .toolbox:hover {
    overflow-y: auto;
    width: calc(100% - 1px);
  }

  .tool-main {
    .tool-main-cont {
      justify-content: center;
      align-items: center;
      height: 450px;
      width: 450px;
      margin: 0 auto;
      // background-color: #006FFF;
      background-image: url("../assets/img/textform/bg.png");
      flex-direction: column;
    }
  }
}

.img-cont {
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background-color: #f5f6f9;
  margin: 0 auto;
}

.bottom-cont {
  box-sizing: border-box;
  border: none;
  max-height: 124px;
  padding: 10px 0;
  //min-height: 66px;
  background: #222337;
  border-radius: 10px;
  textarea {
    border: none;
    resize: none;
    cursor: pointer;
  }
}

.history {
  text-align: left;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
  height: 100%;

  .title {
    box-sizing: border-box;
    padding: 0 30px 0 0;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    position: relative;
  }

  ::v-deep .el-tabs__item.is-active .title:after {
    content: "";
    display: block;
    width: 20px;
    height: 4px;
    background: linear-gradient(315deg, #006fff 0%, #72e3f5 100%);
    border-radius: 2px;
    position: absolute;
    bottom: 2px;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: transparent !important;
  }

  ::v-deep .el-tabs__item.is-active .t1:after {
    left: 7px;
  }

  ::v-deep .el-tabs__item.is-active .t2:after {
    left: 7px;
  }
  ::v-deep .el-tabs__item.is-active .t2:after {
    left: 12px;
  }

  ::v-deep .el-tabs__header.is-top {
    margin-bottom: 11px;
  }

  .scroll-cont {
    height: calc(100% - 25px);
    position: relative;
  }
  .scroll-cont {
    overflow: hidden;
  }
  .scroll-cont::-webkit-scrollbar {
    width: 5px;
    display: flex;
  }
  .scroll-cont::-webkit-scrollbar-thumb {
  }
  .scroll-cont:hover {
    overflow-y: auto;
    // width: calc(100% - 1px )
  }

  .his-item {
    box-sizing: border-box;
    border-radius: 5px;
    flex-wrap: wrap;
    width: 130px;
    height: 130px;
    margin-bottom: 5px;
    align-content: stretch;
    position: relative;
    overflow: hidden;

    .imgB1 {
      width: 130px;
      height: 130px;
    }
    .imgB2 {
      width: 65px;
      height: 130px;
    }
    .imgB3 {
      width: 65px;
      height: 65px;
    }
    .imgB4 {
      width: 65px;
      height: 65px;
    }
    img {
      width: 50%;
      height: 50%;
    }
    .top_model {
      position: absolute;
      top: 0;
      width: 100%;
      left: 0;
      right: 0;
      height: 34px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.7) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      z-index: 10;
      display: none;
    }
    .deleteIcon {
      display: none;
    }
  }
  .his-item:nth-child(2n + 2) {
    margin-right: 10px;
  }

  .his-item:hover {
    .top_model {
      display: block;
    }
    .deleteIcon {
      display: block;
    }
  }
}

.carousel-cont .carousel-caption {
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
}

.exit_hover .arrowClickIcon {
  display: none;
}
.exit_hover:hover .arrowClickIcon {
  display: inline-block;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
